module.exports = __webpack_public_path__ + "img/CHINAUMS_SCAN2.a718b86a.png";